export default {
  namespaced  : true,

  state       : {
    loopManager  : [
      // {
      //   type    : 'flash',
      //   message : '更新作業を行っております。',
      //   loop    : true, // trueの場合は無限、数字指定で回数、falseで１回
      // },
    ],
    
    messageManager      : [],

    currentLine       : 'loop',
    flashLineObject   : null,
  },
  
  mutations   : {
    setNextObject(state, payload){
      state.currentLine     = payload.line;
      state.flashLineObject = payload.data;
    },

    pushFlashManager(state, payload){
      switch(payload.line){
        case 'loop':
          state.loopManager.push(payload.data);
        break;

        case 'message':
          if(Array.isArray(payload.data)){
            for(let i = 0; i < payload.data.length; i++){
              state.messageManager.push(payload.data[i]);
            }
          }else{
            state.messageManager.push(payload.data);
          }
        break;
      }
    },

    shiftMessageManager(state){
      state.messageManager.shift();
    },
    
    shiftLoopManager(state){
      state.loopManager.shift();
    },

    resetStore(state){
      state.loopManager     = [];
      state.messageManager  = [];
      state.currentLine     = 'loop';
      state.flashLineObject = null;
    }
  },

  actions   : {
    requestNextObject(context){
      if(context.state.messageManager.length !== 0){
        context.commit('setNextObject', {
          line  : 'message',
          data  : context.state.messageManager[0]
        });

        context.commit('shiftMessageManager');
      }else{
        if(context.state.loopManager.length > 1){
          context.commit('shiftLoopManager');
        }
        
        context.commit('setNextObject', {
          line  : 'loop',
          data  : context.state.loopManager[0]
        });
      }
    },

    pushFlashMessage(context, payload){
      context.commit('pushFlashManager',payload);
    },

    testAddAlert(context){
      context.commit('setNextObject', {
        line  : 'message',
        data  : {
          type    : 'alert',
          message : '！！！緊急情報！！！',
          loop    : 5, // trueの場合は無限、数字指定で回数、falseで１回
        }
      });
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}